export class Link {
    id: number;
    site: string;
    descricao: string;
    imagem: string;
    url: string;
}